var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-view"},[_c('h1',{staticClass:"login-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('ve-form',{staticClass:"login-form",attrs:{"view":_vm.form,"value":_vm.value,"onSubmit":_vm.onSubmit}}),_vm._v("admin: admin\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4042c27f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/Login.vue
// module id = null
// module chunks = 